<template>
  <div class="max-w-[1500px]">
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex gap-6">
      <div class="w-[620px] border rounded-xl p-4">
        <h2 class="text-gray-800 font-semibold text-sm mb-1">
          Unmapped Courses
        </h2>
        <div class="relative mb-3">
          <div
            class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
          >
            <svg
              class="w-4 h-4 text-slate-400"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 21l-4.35-4.35M16.65 10.5a6.15 6.15 0 11-12.3 0 6.15 6.15 0 0112.3 0z"
              />
            </svg>
          </div>

          <input
            type="text"
            placeholder="Search"
            v-model="searching"
            @input="getUnmappedcourse"
            class="w-full border rounded-lg pl-10 pr-3 py-2 text-sm"
          />
        </div>

        <div class="border rounded-lg h-[320px] overflow-y-auto w-full">
          <div
            v-if="unmappedCourse.length === 0"
            class="flex items-center justify-center h-full text-gray-400 text-sm"
          >
            No courses available
          </div>
          <div
            v-else
            v-for="(item, index) in unmappedCourse"
            :key="index"
            class="flex items-center gap-3 px-4 py-2 border-b text-sm hover:bg-gray-100"
            :class="item.is_published ? 'text-gray-800' : 'text-gray-500'"
          >
            <input
              type="checkbox"
              v-model="selectedUnmapped"
              :value="item.id"
              class="w-4 h-4"
            />

            <!-- Title with conditional styling -->
            <span :class="item.is_published ? 'font-normal' : 'line-through'">
              {{ item.title }}
            </span>

            <!-- Published: Green check -->
            <span v-if="item.is_published" class="ml-auto" title="Published">
              <svg
                class="w-4 h-4 text-green-500 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>

            <!-- Unpublished: Gray X -->
            <span v-else class="ml-auto" title="Unpublished">
              <svg
                class="w-4 h-4 text-gray-400 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-center gap-4">
        <button
          v-if="!loadingMap"
          @click="moveToMapped()"
          :disabled="selectedUnmapped.length === 0"
          :class="
            selectedUnmapped.length === 0
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-slate-800 hover:bg-hover text-white'
          "
          class="w-10 h-10 rounded-full flex items-center justify-center shadow"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#ffffff"
          >
            <path
              d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"
            />
          </svg>
        </button>
        <div
          v-else
          class="w-10 h-10 rounded-full flex items-center justify-center shadow bg-slate-800"
        >
          <img
            src="@/assets/loading.gif"
            alt="loading"
            class="w-6 h-6 object-contain"
          />
        </div>

        <button
          v-if="!loadingUnmap"
          @click="moveToUnmapped()"
          :disabled="selectedMapped.length === 0"
          :class="
            selectedMapped.length === 0
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-slate-800 hover:bg-hover text-white'
          "
          class="w-10 h-10 rounded-full flex items-center justify-center shadow"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#ffffff"
          >
            <path
              d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"
            />
          </svg>
        </button>
        <div
          v-else
          class="w-10 h-10 rounded-full flex items-center justify-center shadow bg-slate-800"
        >
          <img
            src="@/assets/loading.gif"
            alt="loading"
            class="w-6 h-6 object-contain"
          />
        </div>
      </div>

      <div class="w-[620px] border rounded-xl p-4">
        <h2 class="text-grat-800 font-semibold text-sm mb-1">Mapped Courses</h2>

        <div class="relative mb-3">
          <div
            class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
          >
            <svg
              class="w-4 h-4 text-slate-400"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 21l-4.35-4.35M16.65 10.5a6.15 6.15 0 11-12.3 0 6.15 6.15 0 0112.3 0z"
              />
            </svg>
          </div>

          <input
            type="text"
            placeholder="Search"
            v-model="searchFilter"
            @input="getMappedcourse"
            class="w-full border rounded-lg pl-10 pr-3 py-2 text-sm"
          />
        </div>

        <div class="border rounded-lg h-[320px] overflow-y-auto w-full">
          <div
            v-if="mappedCourse.length === 0"
            class="flex items-center justify-center h-full text-gray-400 text-sm"
          >
            No courses available
          </div>
          <div
            v-else
            v-for="(item, index) in mappedCourse"
            :key="index"
            class="flex items-center gap-3 px-4 py-2 border-b text-sm hover:bg-gray-100"
            :class="item.is_published ? 'text-gray-800' : 'text-gray-500'"
          >
            <input
              type="checkbox"
              v-model="selectedMapped"
              :value="item.id"
              class="w-4 h-4"
            />

            <!-- Title with conditional styling -->
            <span :class="item.is_published ? 'font-normal' : 'line-through'">
              {{ item.title }}
            </span>

            <!-- Published: Green check -->
            <span v-if="item.is_published" class="ml-auto" title="Published">
              <svg
                class="w-4 h-4 text-green-500 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>

            <!-- Unpublished: Gray X -->
            <span v-else class="ml-auto" title="Unpublished">
              <svg
                class="w-4 h-4 text-gray-400 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
export default {
  data() {
    return {
      mappedCourse: [],
      unmappedCourse: [],
      searchFilter: "",
      searching: "",
      messages: {
        text: "",
        type: "null",
      },
      selectedMapped: [],
      selectedUnmapped: [],
      permissionList: [],
      loadingMap: false,
      loadingUnmap: false,
    };
  },
  mounted() {
    this.getMappedcourse();
    this.getUnmappedcourse();
    this.getStudentPermission();
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    FlashMessage,
  },
  props: ["student_id"],
  methods: {
    async moveToMapped() {
      try {
        if (this.selectedUnmapped.length === 0) return;
        const existingCourseIds = this.permissionList.course.map((c) => c.id);
        const newCourseIds = this.selectedUnmapped;
        const mergedCourseIds = [
          ...new Set([...existingCourseIds, ...newCourseIds]),
        ];
        const semesterIds = this.permissionList.semester.map((s) => s.id);
        this.loadingMap = true;
        const payload = {
          id: this.permissionList.id,
          is_active: this.permissionList.is_active,
          user: this.permissionList.user.id,
          semester: semesterIds,
          course: mergedCourseIds,
        };
        const response = await axios.put(
          `${process.env.VUE_APP_API}/student_permission/update/${this.student_id}/?Key=${this.userInfo.token_key}`,
          payload,
        );
        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message || "Courses mapped successfully",
            type: "success",
          };
          this.refreshLists();
          this.$emit("trigger");
          this.loadingMap = false;
        }
      } catch (error) {
        this.showError(error);
      }
    },
    refreshLists() {
      this.getMappedcourse();
      this.getUnmappedcourse();
      this.getStudentPermission();
      this.selectedUnmapped = [];
      this.selectedMapped = [];
      setTimeout(() => {
        this.messages.text = "";
      }, 3000);
    },

    showError(error) {
      this.messages = {
        text: error.response?.data?.error || "Operation failed",
        type: "error",
      };
    },

    async moveToUnmapped() {
      try {
        if (this.selectedMapped.length === 0) return;
        const existingCourseIds = this.permissionList.course.map((c) => c.id);
        const removeCourseIds = this.selectedMapped;

        const remainingCourseIds = existingCourseIds.filter(
          (id) => !removeCourseIds.includes(id),
        );

        const semesterIds = this.permissionList.semester.map((s) => s.id);
        this.loadingUnmap = true;
        const payload = {
          id: this.permissionList.id,
          is_active: this.permissionList.is_active,
          user: this.permissionList.user.id,
          semester: semesterIds,
          course: remainingCourseIds,
        };

        const response = await axios.put(
          `${process.env.VUE_APP_API}/student_permission/update/${this.student_id}/?Key=${this.userInfo.token_key}`,
          payload,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message || "Courses unmapped successfully",
            type: "success",
          };
          this.refreshLists();
          this.$emit("trigger");
          this.loadingUnmap = false;
        }
      } catch (error) {
        this.showError(error);
      }
    },

    async getStudentPermission() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student_permission/update/${this.student_id}/?Key=${this.userInfo.token_key}`,
        )

        .then((response) => {
          if (response.data.status == 200) {
            this.permissionList = response.data.data;
          }
        });
    },
    async getMappedcourse() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student/mappedcourse/${this.student_id}/?Key=${this.userInfo.token_key}&search=${this.searchFilter}`,
        )

        .then((response) => {
          if (response.data.status == 200) {
            this.mappedCourse = response.data.data;
          }
        });
    },
    async getUnmappedcourse() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student/unmappedcourse/${this.student_id}/?Key=${this.userInfo.token_key}&search=${this.searching}`,
        )

        .then((response) => {
          if (response.data.status == 200) {
            this.unmappedCourse = response.data.data;
          }
        });
    },
  },
};
</script>
